export function isMock(): boolean {
    return process.env.REACT_APP_MOCK_API === 'true';
}
